<template>
  <div v-if="showModal" class="onr-login">
    <div class="onr-login__modal app-page" :class="loginClasses()" role="dialog">
      <div v-show="page === 0" class="onr-login__modal-container">
        <div class="onr-login__modal-container--left">
          <img class="login-img" src="../../assets/Login_v2_03.jpg"/>
        </div>
        <div v-show="login === 0" class="onr-login__modal-container--right">
          <a class="login-close" @click="closeModal()">
            <svg height="15px" id="Layer_1" viewBox="0 0 512 512" width="15px">
              <path
                  d="M437.5,386.6L306.9,256l130.6-130.6c14.1-14.1,14.1-36.8,0-50.9c-14.1-14.1-36.8-14.1-50.9,0L256,205.1L125.4,74.5  c-14.1-14.1-36.8-14.1-50.9,0c-14.1,14.1-14.1,36.8,0,50.9L205.1,256L74.5,386.6c-14.1,14.1-14.1,36.8,0,50.9  c14.1,14.1,36.8,14.1,50.9,0L256,306.9l130.6,130.6c14.1,14.1,36.8,14.1,50.9,0C451.5,423.4,451.5,400.6,437.5,386.6z"/>
            </svg>
          </a>
          <h1 class="login-heading">Login</h1>
          <input
              class="login-input__email"
              :class="emailClasses()"
              ref="email-login"
              inputType="single-line"
              v-model="submission.email"
              field-id="email"
              placeholder="Username or email"
              @input="validateEmail()"
          />
          <span class="email-error" v-if="showEmailError">Must enter a valid email address.</span>
          <input
              class="login-input__password"
              :class="passwordClasses()"
              ref="password-login"
              inputType="single-line"
              v-model="submission.password"
              field-id="password"
              placeholder="Password"
              type="password"
              @input="validatePassword()"
          />
          <span class="password-error" v-if="showPasswordError">Please enter your password.</span>
          <!-- <div class="login-actions">
            <Checkbox
              class="login-remember"
              v-model="rememberMe"
              name="Remember me"
              @change="onRememberMeChecked()"
            ></Checkbox>
            <span class="login-lost-password">Lost your password?</span>
          </div> -->
          <div class="login-actions">
            <a class="login-lost-password" @click="resetPassword()">Forgot your password?</a>
          </div>
          <button class="button-login" :class="loginButtonClasses()" @click="onLoginSubmit()">Login</button>
          <button type="button" class="gsi-material-button" @click="onGoogleSignIn()">
            <div class="gsi-material-button-state"></div>
            <div class="gsi-material-button-content-wrapper">
              <div class="gsi-material-button-icon">
                <svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" xmlns:xlink="http://www.w3.org/1999/xlink" style="display: block;">
                  <path fill="#EA4335" d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"></path>
                  <path fill="#4285F4" d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"></path>
                  <path fill="#FBBC05" d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z"></path>
                  <path fill="#34A853" d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"></path>
                  <path fill="none" d="M0 0h48v48H0z"></path>
                </svg>
              </div>
              <span class="gsi-material-button-contents">Continue with Google</span>
            </div>
          </button>
          <span class="no-account-text">No account yet?</span>
          <button class="button-create" @click="showCreateAccountOverlay()">Create Account</button>
        </div>
        <div v-show="login === 1" class="referral-container onr-login__modal-container--right">
          <a class="login-close" @click="closeModal()">
            <svg height="15px" id="Layer_1" viewBox="0 0 512 512" width="15px">
              <path
                  d="M437.5,386.6L306.9,256l130.6-130.6c14.1-14.1,14.1-36.8,0-50.9c-14.1-14.1-36.8-14.1-50.9,0L256,205.1L125.4,74.5  c-14.1-14.1-36.8-14.1-50.9,0c-14.1,14.1-14.1,36.8,0,50.9L205.1,256L74.5,386.6c-14.1,14.1-14.1,36.8,0,50.9  c14.1,14.1,36.8,14.1,50.9,0L256,306.9l130.6,130.6c14.1,14.1,36.8,14.1,50.9,0C451.5,423.4,451.5,400.6,437.5,386.6z"/>
            </svg>
          </a>
          <ReferralCodePage @verify="verify"></ReferralCodePage>
        </div>
        <div v-show="login === 3" class="signup-method onr-login__modal-container--right">
          <a class="login-close" @click="closeModal()">
            <svg height="15px" id="Layer_1" viewBox="0 0 512 512" width="15px">
              <path
                  d="M437.5,386.6L306.9,256l130.6-130.6c14.1-14.1,14.1-36.8,0-50.9c-14.1-14.1-36.8-14.1-50.9,0L256,205.1L125.4,74.5  c-14.1-14.1-36.8-14.1-50.9,0c-14.1,14.1-14.1,36.8,0,50.9L205.1,256L74.5,386.6c-14.1,14.1-14.1,36.8,0,50.9  c14.1,14.1,36.8,14.1,50.9,0L256,306.9l130.6,130.6c14.1,14.1,36.8,14.1,50.9,0C451.5,423.4,451.5,400.6,437.5,386.6z"/>
            </svg>
          </a>
          <h1 class="login-heading">Sign up</h1>
          <p class="signup-method__text">Choose how you'd like to create your account.</p>
          <button type="button" class="gsi-material-button" @click="onGoogleSignupChoice()">
            <div class="gsi-material-button-state"></div>
            <div class="gsi-material-button-content-wrapper">
              <div class="gsi-material-button-icon">
                <svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" xmlns:xlink="http://www.w3.org/1999/xlink" style="display: block;">
                  <path fill="#EA4335" d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"></path>
                  <path fill="#4285F4" d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"></path>
                  <path fill="#FBBC05" d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z"></path>
                  <path fill="#34A853" d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"></path>
                  <path fill="none" d="M0 0h48v48H0z"></path>
                </svg>
              </div>
              <span class="gsi-material-button-contents">Sign up with Google</span>
            </div>
          </button>
          <button class="button-create" @click="continueWithEmail()">Continue with Email</button>
        </div>
      </div>
      <CreateAccountForm v-show="page === 1" :google-mode="googleMode" @close="closeModal()"></CreateAccountForm>
    </div>
  </div>
</template>

<script>
//import { find } from 'lodash';
// import Checkbox from '../checkbox.vue'

import {isEmpty} from 'lodash';
import {getUser} from '@/api';
import sampleLogins from '../../data/sampleLogins.json';
import users from '../../data/instructors.json';
import ReferralCodePage from '../../views/LogIn/ReferralCodePage.vue';
import CreateAccountForm from '../../views/LogIn/CreateAccountForm.vue';
import {signInWithPopup} from "firebase/auth";
import {auth, sendPasswordResetEmail, googleProvider} from "@/firebase.config";
import {isNjonnuriBypassCode, NJONNURI_BYPASS_CODE, NJONNURI_BYPASS_ROLE} from "@/utils/referralBypass";

export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: 'login-overlay',
  props: {
    showModal: Boolean,
    startWithCreateAccount: Boolean,
    redirect: { type: [Object, String], default: null },
  },
  data() {
    return {
      showEmailError: false,
      showPasswordError: false,
      verified: false,
      login: 0,
      page: 0,
      showCreateAccount: false,
      rememberMe: false,
      // True once a brand-new Google identity (no `users` DB row yet) has
      // been routed into the referral+CreateAccountForm flow — tells
      // CreateAccountForm to skip the password field and call a different
      // completion action, since Google already authenticated this user.
      googleMode: false,
      submission: {
        email: '',
        password: '',
      }
    };
  },
  mounted() {
    this.logins;
    this.users;
    this.beginCreateAccountIfRequested();
  },
  components: {
    ReferralCodePage,
    CreateAccountForm,
    // Checkbox,
  },
  computed: {
    logins() {
      return sampleLogins;
    },
    users() {
      return users;
    },
  },
  methods: {
    resetModalState() {
      this.showEmailError = false;
      this.showPasswordError = false;
      this.verified = false;
      this.login = 0;
      this.page = 0;
      this.showCreateAccount = false;
      this.rememberMe = false;
      this.googleMode = false;
      this.submission.password = '';
    },
    beginCreateAccountIfRequested() {
      if (this.showModal && this.startWithCreateAccount) {
        this.$nextTick(() => this.showCreateAccountOverlay());
      }
    },
    resetPassword() {
      if (!this.submission.email) {
        alert("Please type in a valid email address.");
        return;
      }
      sendPasswordResetEmail(auth, this.submission.email).then(function () {
        alert("Password reset email sent.");
      }).catch(function (error) {
        alert(error.message);
      });

    },
    clearError(type) {
      if (type === 'email') {
        this.showEmailError = false;
      } else if (type === 'password') {
        this.showPasswordError = false;
      }
    },
    passwordClasses() {
      return this.showPasswordError ? 'has-password-error' : '';
    },
    emailClasses() {
      return this.showEmailError ? 'has-email-error' : '';
    },
    // Returns true if the current URL carries the njonnuri bypass and has
    // set localStorage accordingly — shared between the password-signup
    // entry point (showCreateAccountOverlay) and the Google entry point
    // (onGoogleSignIn) so both recognize it identically.
    tryUrlNjonnuriBypass() {
      const params = new URLSearchParams(window.location.search);
      const code = params.get('code');
      if (isNjonnuriBypassCode(code)) {
        localStorage.setItem('code', NJONNURI_BYPASS_CODE);
        localStorage.setItem('role', NJONNURI_BYPASS_ROLE);
        return true;
      }
      return false;
    },
    showCreateAccountOverlay() {
      if (this.tryUrlNjonnuriBypass()) {
        // referral 단계 건너뛰고 방식 선택 화면으로
        this.verify();
        return;
      }
      this.login = 1;
    },
    loginButtonClasses() {
      return !this.showEmailError && !this.showPasswordError ? '' : 'login-disabled';
    },
    loginClasses() {
      return this.page === 1 ? 'full-overlay' : '';
    },
    closeModal() {
      localStorage.removeItem('code');
      localStorage.removeItem('role');
      this.resetModalState();
      this.$emit('close');
    },
    verify() {
      // Referral step done (or bypassed) — let the user choose how to sign
      // up next, rather than assuming email/password.
      this.login = 3;
    },
    enterCreateAccountForm() {
      this.login = null;
      this.page = 1;
    },
    continueWithEmail() {
      this.enterCreateAccountForm(); // googleMode stays false — unchanged form
    },
    async validatedUser() {
      await getUser();
    },
    validateEmail() {
      const regex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      const isValidEmail = regex.test(this.submission.email);
      if (!isEmpty(this.submission.email) && !isValidEmail) {

        this.showEmailError = true;
      } else {
        this.showEmailError = false;
      }
    },
    validatePassword() {
      this.showPasswordError = isEmpty(this.submission.password);
    },
    finishLogin() {
      // Read before emitting close: the parent clears the redirect when the modal closes.
      const target = this.redirect || { name: 'StudentPage' };
      this.resetModalState();
      this.$emit('close');
      this.$router.push(target);
    },
    onLoginSubmit() {
      this.validateEmail();
      this.validatePassword();
      this.$store.dispatch('authStore/logIn', this.submission).then(() => {
        this.finishLogin();
      }).catch((error) => {
        console.error(error);
      });
    },
    // Runs the Google popup and commits the resulting Firebase user to Vuex,
    // then reports whether a `users` DB profile row exists for this uid yet.
    // Shared by onGoogleSignIn() (top login-panel button) and
    // onGoogleSignupChoice() (the dedicated "Create Account" flow's method
    // choice) so the popup+existence-check logic lives in exactly one place.
    async signInWithGooglePopup() {
      const credential = await signInWithPopup(auth, googleProvider);
      await this.$store.dispatch('authStore/authSignIn', credential.user);

      try {
        await getUser();
        return { isNewUser: false };
      } catch (error) {
        if (error.response?.status === 404) {
          return { isNewUser: true };
        }
        throw error; // transient failure — fail closed, don't guess
      }
    },
    async onGoogleSignIn() {
      try {
        const { isNewUser } = await this.signInWithGooglePopup();

        if (isNewUser) {
          // Brand-new Google identity, no profile row yet — same
          // referral-gated flow every other new user goes through; only
          // the password step is skipped (handled by CreateAccountForm).
          this.googleMode = true;
          if (this.tryUrlNjonnuriBypass()) {
            this.verify();
            return;
          }
          this.login = 1;
          return;
        }

        // Existing user (a DB row was found) — identical tail to onLoginSubmit().
        this.finishLogin();
      } catch (error) {
        console.error(error);
        alert(error.message || 'Google sign-in failed. Please try again.');
      }
    },
    // The "Create Account" flow's method-choice step: referral is already
    // done by the time this runs, so a new user goes straight to the form
    // instead of back through the referral step.
    async onGoogleSignupChoice() {
      try {
        const { isNewUser } = await this.signInWithGooglePopup();

        if (isNewUser) {
          this.googleMode = true;
          this.enterCreateAccountForm();
          return;
        }

        // This Google account turns out to already have a profile — log
        // them in instead of erroring, same tail as onGoogleSignIn().
        this.finishLogin();
      } catch (error) {
        console.error(error);
        alert(error.message || 'Google sign-in failed. Please try again.');
      }
    },
  },
  watch: {
    showModal(value) {
      if (value) {
        this.beginCreateAccountIfRequested();
        return;
      }

      this.resetModalState();
    },
    startWithCreateAccount() {
      this.beginCreateAccountIfRequested();
    },
  },
}
</script>

<style lang="scss">
@use '../../utils/_tokens.scss' as *;

.onr-login {
  z-index: 3;
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: rgba(0, 0, 0, 0.4);

  @media only screen and (max-width: 650px) {
    .onr-login__modal {
      width: 20em;
    }
  }

  &__modal {
    display: flex;
    position: absolute;
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    margin: auto;
    text-align: center;
    width: 39em;
    height: 30em;
    background: #FFF;
    z-index: 999;
    transform: none;

    &.full-overlay {
      justify-content: center;
      width: 90%;
      height: 40em;
      overflow: scroll;
    }

    &-container {
      display: flex;
      position: absolute;
      position: fixed;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      margin: auto;
      text-align: center;
      width: 39em;
      height: 30em;
      background: #FFF;
      z-index: 999;
      transform: none; //TODO: clean this up

      @media only screen and (max-width: 650px) {
        .onr-login__modal-container--left {
          display: none;
        }
        width: 20em;
      }

      &--left {
        height: inherit;

        .login-img {
          max-width: 20em;
          height: inherit;
        }
      }

      &--left, &--right {
        flex-direction: column;
      }

      &--right {
        &.referral-container {
          display: flex;
          align-items: center;
        }

        .password-error, .email-error {
          color: red;
          font-size: 10px;
          margin-bottom: 10px;
          text-align: left;
          margin-left: 1rem;
        }

        display: flex;
        flex-direction: column;
        width: inherit;

        .no-account-text {
          font-size: 15px;
          text-align: left;
          margin: 40px 0 0 25px;
        }

        .signup-method__text {
          color: $grey-1;
          font-size: 14px;
          margin: 10px 25px 20px;
          text-align: left;
        }

        .button {
          &-login, &-create {
            background-color: $blue-1;
            border-radius: 25px;
            border: unset;
            height: 40px;
            margin: 5px 20px;
            font-size: 15px;
            text-transform: uppercase;
            color: white;
            cursor: pointer;
          }

        }

        // Google's official "Sign in with Google" branded button
        // (https://developers.google.com/identity/branding-guidelines).
        // Width is auto here (not the configurator's hardcoded 272px) so it
        // lines up with this panel's existing 250px-wide inputs instead.
        .gsi-material-button {
          -moz-user-select: none;
          -webkit-user-select: none;
          -ms-user-select: none;
          -webkit-appearance: none;
          background-color: WHITE;
          background-image: none;
          border: 1px solid #747775;
          border-radius: 20px;
          box-sizing: border-box;
          color: #1f1f1f;
          cursor: pointer;
          font-family: 'Roboto', arial, sans-serif;
          font-size: 14px;
          height: 40px;
          letter-spacing: 0.25px;
          margin: 8px 20px 0;
          outline: none;
          overflow: hidden;
          padding: 0 12px;
          position: relative;
          text-align: center;
          transition: background-color .218s, border-color .218s, box-shadow .218s;
          vertical-align: middle;
          white-space: nowrap;
          width: auto;

          .gsi-material-button-icon {
            height: 20px;
            margin-right: 12px;
            min-width: 20px;
            width: 20px;
          }

          .gsi-material-button-content-wrapper {
            align-items: center;
            display: flex;
            flex-direction: row;
            flex-wrap: nowrap;
            height: 100%;
            justify-content: center;
            position: relative;
            width: 100%;
          }

          .gsi-material-button-contents {
            flex-grow: 0;
            font-family: 'Roboto', arial, sans-serif;
            font-weight: 500;
            overflow: hidden;
            text-overflow: ellipsis;
            vertical-align: top;
          }

          .gsi-material-button-state {
            transition: opacity .218s;
            bottom: 0;
            left: 0;
            opacity: 0;
            position: absolute;
            right: 0;
            top: 0;
          }

          &:disabled {
            cursor: default;
            background-color: #ffffff61;
            border-color: #1f1f1f1f;

            .gsi-material-button-contents,
            .gsi-material-button-icon {
              opacity: 38%;
            }
          }

          &:not(:disabled):active .gsi-material-button-state,
          &:not(:disabled):focus .gsi-material-button-state {
            background-color: #303030;
            opacity: 12%;
          }

          &:not(:disabled):hover {
            box-shadow: 0 1px 2px 0 rgba(60, 64, 67, .30), 0 1px 3px 1px rgba(60, 64, 67, .15);

            .gsi-material-button-state {
              background-color: #303030;
              opacity: 8%;
            }
          }
        }

        .login {
          &-disabled {
            background-color: grey;
            cursor: not-allowed;
          }

          &-heading {
            font-size: 38px;
            text-transform: uppercase;
            text-align: left;
            margin: 20px 0 0 20px;
            font-weight: 200;
          }

          &-input {
            &__email, &__password {
              border: 1px solid $grey-4;
              height: 35px;
              padding-left: 0.7rem;
              margin-bottom: 1rem;
              margin-left: 1rem;
              width: 250px;
            }

            &__password {
              &.has-password-error {
                margin-bottom: 5px;
              }
            }

            &__email {
              &.has-email-error {
                margin-bottom: 5px;
              }
            }
          }

          &-close {
            right: 11px;
            position: absolute;
            top: 8px;
            cursor: pointer;

            svg {
              fill: grey;
            }
          }

          &-actions {
            margin: 8px 25px 10px 20px;

            .login {
              &-remember {
                font-size: 12px;
                text-transform: uppercase;
                font-weight: 600;
                float: left;
              }

              &-lost-password {
                text-decoration: underline;
                font-size: 13px;
                float: right;
                cursor: pointer;
              }
            }
          }
        }

        .text-input__wrapper {
          margin: 10px 20px;
          width: auto;

          .text-input {
            width: 90%;
          }
        }
      }
    }
  }
}


/* Public design tone (src/styles/site.css tokens). The overlay renders inside .tdi
   (SiteHeader), so these .tdi-prefixed rules override the layout rules above. */
.tdi .onr-login {
  background-color: rgba(22, 26, 63, .55);
  z-index: 90;

  .onr-login__modal,
  .onr-login__modal-container {
    border-radius: 22px;
    box-shadow: var(--shadow);
    overflow: hidden;
  }

  // The create-account form (esp. the availability step) is taller than 40em,
  // so cap the modal to the viewport and let it scroll instead of clipping.
  .onr-login__modal.full-overlay {
    align-items: flex-start;
    height: fit-content;
    max-height: calc(100vh - 2rem);
    max-height: calc(100dvh - 2rem);
    overflow-y: auto;
  }

  .onr-login__modal-container--right {
    .login-heading {
      color: var(--ink);
      font-family: var(--display);
      font-size: 34px;
      font-weight: 600;
      letter-spacing: -.01em;
      text-transform: none;
    }

    .login-input__email,
    .login-input__password {
      border: 1px solid var(--line);
      border-radius: 12px;
      font-family: var(--display);
      font-size: 16px;
      height: 44px;
      padding-left: 14px;

      &:focus {
        border-color: var(--focus);
        box-shadow: 0 0 0 3px rgba(59, 70, 184, .18);
        outline: none;
      }
    }

    .button-login,
    .button-create {
      font-family: var(--display);
      font-size: 16px;
      font-weight: 600;
      height: 46px;
      letter-spacing: .01em;
      text-transform: none;
      transition: transform .15s ease;

      &:hover {
        transform: translateY(-1px);
      }
    }

    .button-login {
      background-color: var(--primary);
      color: var(--on-primary);
    }

    .button-create {
      background-color: transparent;
      border: 2px solid var(--line);
      color: var(--ink);

      &:hover {
        border-color: var(--ink-2);
      }
    }

    .login-disabled {
      background-color: var(--line);
      color: var(--ink-2);
    }

    .login-actions .login-lost-password {
      border-bottom: 2px solid var(--gold);
      font-family: var(--display);
      font-weight: 600;
      text-decoration: none;
    }

    .no-account-text,
    .signup-method__text {
      color: var(--ink-2);
      font-family: var(--display);
    }

    .password-error,
    .email-error {
      color: $red-1;
      font-size: 13px;
    }
  }

}
</style>
